import React, { useEffect, useState, useRef } from 'react';
import { __ } from '@wordpress/i18n';
import { useNavigate } from 'react-router-dom';
import { pathOr } from 'ramda';
import NumberFlow from '@number-flow/react';

// api
import DashboardService from '../../service/dashboard-service';
import CompanyDocumentsService from '../../service/company-documents-service';
import { Toast } from 'primereact/toast';

// components
import { Button } from 'primereact/button';
//import ChartDomandePerBando from '../../components/ChartDomandePerBando';
//import ChartStatoDomande from '../../components/ChartStatoDomande';
import BadgeClassic from '../../components/BadgeClassic';
import LatestUsersActivityTableAsync from './components/LatestUsersActivityTableAsync';
import ErrorBoundary from '../../components/ErrorBoundary';
import ListCompaniesForAdminTable from './components/ListCompaniesForAdminTable';


const Dashboard = () => {
    const navigate = useNavigate();
    const [mainStats, setMainStats] = useState({});
    const toast = useRef(null);
    const [sollecitando, setSollecitando] = useState(false);

    const sollecitaIncompleti = () => {
        setSollecitando(true);
        CompanyDocumentsService.runCompletionReminders(
            (resp) => {
                setSollecitando(false);
                if (toast.current) toast.current.show({ severity: resp.status === 'SUCCESS' ? 'success' : 'warn', summary: '', detail: resp.message });
            },
            (err) => {
                setSollecitando(false);
                if (toast.current) toast.current.show({ severity: 'error', summary: '', detail: (err && err.message) || 'Errore' });
            }
        );
    };
    //const [chartStats, setChartStats] = useState({});

    const onGoToSuppliers = () => {
        navigate('/fornitori');
    }

    const onGoToUsers = () => {
        navigate('/utenti');
    }

    /*const onGoToStats = () => {
        console.log('onGoToStats')
    }

    const onGoToSettings = () => {
        console.log('onGoToSettings')
    }*/

    const getStatValue = (key, fallback = '') => {
        return pathOr(fallback, [key], mainStats);
    }

    const getPercentageStatValue = (value) => {
        return `${value}%`;
    }

    const getStats = (data) => {
        if (data.status === 'SUCCESS') {
            setMainStats(data.data.widget1);
        }
    }

    const errGetStats = () => {
    }

    useEffect(() => {
        DashboardService.getAdminStats(getStats, errGetStats);
    }, []);

    return (
        <div className="appPage">
            <div className="appPage__pageHeader">
                <h1>{__('Dashboard', 'htr')}</h1>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection statsBigBadges">
                <h2>{__('Panoramica di Sistema', 'htr')}</h2>
                <div className="statsBigBadges__grid">
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Fornitori', 'htr')}</span>
                        <span className="value"><NumberFlow
                            value={getStatValue('totalNumberOfCompany', 7)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                        <span className="faded">{__('Nuovi:', 'htr')} <NumberFlow
                            value={getStatValue('newCompanyCurrentMonth', 7)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                        <div className="meta">
                            <BadgeClassic label={getPercentageStatValue(getStatValue('currentVsLastMonthCompanyPercentage', 0))} value={getStatValue('currentVsLastMonthCompanyPercentage', 0)}/>
                            {__('Rispetto al mese precedente', 'htr')}
                        </div>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Utenti registrati', 'htr')}</span>
                        <span className="value"><NumberFlow
                            value={getStatValue('totalNumberOfConfidiUser', 12)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                        <span className="faded">{__('Nuovi:', 'htr')} <NumberFlow
                            value={getStatValue('newConfidiUserCurrentMonth', 7)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                        <div className="meta">
                            <BadgeClassic label={getPercentageStatValue(getStatValue('currentVsLastMonthConfidiUserPercentage', 0))} value={getStatValue('currentVsLastMonthConfidiUserPercentage', 0)}/>
                            {__('Rispetto al mese precedente', 'htr')}
                        </div>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Operatori HTR', 'htr')}</span>
                        <span className="value"><NumberFlow
                            value={getStatValue('totalNumberOfOperatorUser', 3)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                        <span className="faded">{__('Nuovi:', 'htr')} <NumberFlow
                            value={getStatValue('newOperatorCurrentMonth', 7)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                        <div className="meta">
                            <BadgeClassic label={getPercentageStatValue(getStatValue('currentVsLastMonthOperatorPercentage', 0))} value={getStatValue('currentVsLastMonthOperatorPercentage', 0)}/>
                            {__('Rispetto al mese precedente', 'htr')}
                        </div>
                    </div>
                    <div className="statsBigBadges__gridItem">
                        <span>{__('Documentazione da valutare', 'htr')}</span>
                        <span className="value"><NumberFlow
                            value={getStatValue('totalNumberOfDocumentNotValidated', 1)}
                            format={{ notation: 'compact' }}
                            locales="it-IT"/></span>
                        <div className="meta">
                            <BadgeClassic label={getPercentageStatValue(getStatValue('currentVsLastMonthDocumentNotValidatedPercentage', 0))} value={getStatValue('currentVsLastMonthDocumentNotValidatedPercentage', 0)}/>
                            {__('Rispetto al mese precedente', 'htr')}
                        </div>
                    </div>
                </div>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <Toast ref={toast}/>
                <div className="appPageSection__actions">
                    <h2>{__('Nuovi fornitori Registrati', 'htr')}</h2>
                    <Button
                        type="button"
                        label={__('Sollecita chi non ha completato', 'htr')}
                        icon="pi pi-envelope" iconPos="right"
                        loading={sollecitando}
                        onClick={sollecitaIncompleti}/>
                </div>
                <ErrorBoundary><ListCompaniesForAdminTable/></ErrorBoundary>
            </div>

            {/*<div className="appPage__spacer"></div>

            <div className="appPageSection">
                <h2>{__('Attività Recenti Operatori', 'htr')}</h2>
                <LatestUsersActivityTableAsync/>
            </div>*/}

            <div className="appPage__spacer"></div>

            <div className="appPageSection__hr">
                <span>{__('Collegamenti rapidi', 'htr')}</span>
            </div>

            <div className="appPage__spacer"></div>

            <div className="appPageSection">
                <div className="appPageSection__actions">
                    <Button
                        onClick={onGoToSuppliers}
                        label={__('Gestione fornitori', 'htr')} icon="pi pi-building" iconPos="right"/>
                    <Button
                        onClick={onGoToUsers}
                        label={__('Gestione operatori', 'htr')} icon="pi pi-users" iconPos="right"/>
                </div>
            </div>
        </div>
    )
}

export default Dashboard;